// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#video_clip_embed_frame[data-v-17ee7abf]{max-width:100%}", ""]);
// Exports
module.exports = exports;
